const featureUsageApi = ({ apiClient }) => ({
  report(params, headers = {}) {
    return apiClient.get('feature-usage/report', {}, params, headers)
  },
  summary(params, headers = {}) {
    return apiClient.get('feature-usage/summary', {}, params, headers)
  },
})

export default featureUsageApi
